import { useMutation } from '@tanstack/react-query';
import { toast } from '../../../lib/toast';
import { sendPasswordReset } from '../api/users';

function extractErrorMessage(err: unknown): string {
  const axiosErr = err as { response?: { data?: { detail?: string; title?: string } } };
  return axiosErr.response?.data?.detail ?? axiosErr.response?.data?.title ?? 'Failed to send password reset email';
}

export function useSendPasswordReset(onSuccess?: () => void) {
  return useMutation({
    mutationFn: (userId: string) => sendPasswordReset(userId),
    onSuccess: () => {
      toast.success('Password reset email sent');
      onSuccess?.();
    },
    onError: (err: unknown) => {
      toast.error(extractErrorMessage(err));
    },
  });
}
